// Module
var code = "<menu class=\"setup\" setup=\"true\"></menu> <div class=\"root\"> <ui-view></ui-view> </div> ";
// Exports
module.exports = code;